import { render, staticRenderFns } from "./PhoneBooking.vue?vue&type=template&id=64c3a2d8&scoped=true"
import script from "./PhoneBooking.vue?vue&type=script&lang=js"
export * from "./PhoneBooking.vue?vue&type=script&lang=js"
import style0 from "./PhoneBooking.vue?vue&type=style&index=0&id=64c3a2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3a2d8",
  null
  
)

export default component.exports